import Keycloak from 'keycloak-js';

let authInitPromise = null;

export async function initKeycloakAuth(backendUrl) {
  if (authInitPromise) {
    return authInitPromise;
  }

  authInitPromise = initKeycloakAuthOnce(backendUrl);
  return authInitPromise;
}

async function initKeycloakAuthOnce(backendUrl) {
  const response = await fetch(`${backendUrl}/api/auth/config`);
  if (!response.ok) {
    throw new Error('Nie udalo sie pobrac konfiguracji Keycloak');
  }

  const config = await response.json();
  if (!config.enabled) {
    return { enabled: false, client: null };
  }

  if (!config.serverUrl || !config.realm || !config.clientId) {
    throw new Error('Brak wymaganej konfiguracji Keycloak');
  }

  if (!window.isSecureContext || !window.crypto?.subtle) {
    throw new Error(
      'Web Crypto API jest niedostepne. Logowanie Keycloak z PKCE wymaga HTTPS albo uruchomienia na localhost. ' +
      'Wejdz na aplikacje przez https://... lub skonfiguruj reverse proxy z TLS.'
    );
  }

  const client = new Keycloak({
    url: config.serverUrl,
    realm: config.realm,
    clientId: config.clientId,
  });

  const authenticated = await client.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
    redirectUri: `${window.location.origin}${window.location.pathname}`,
  });

  if (!authenticated) {
    throw new Error('Nie udalo sie potwierdzic logowania w Keycloak');
  }

  return { enabled: true, client };
}

export async function getAuthHeaders(auth) {
  if (!auth?.enabled || !auth.client) {
    return {};
  }

  try {
    await auth.client.updateToken(30);
  } catch (error) {
    await auth.client.login();
    throw error;
  }

  return {
    Authorization: `Bearer ${auth.client.token}`,
  };
}
